import { schema } from 'normalizr';

const memberSchema = new schema.Entity('members', {
  // labels: [labelSchema],
  // analyticalLabels: [labelSchema],
  directManagers: [new schema.Entity('members')],
});

export default memberSchema;
